exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-photo[data-v-d3ebdcee]{cursor:pointer;margin:auto}", ""]);

// exports
